<template>
  <div>
    <div class="overlay" @click="closeModal"></div>
    <div class="modal_fixed" v-show="isActiveModal()">
      <div :class="[!!hasExtraModalClass ? hasExtraModalClass : '']" :id="modalKey">
        <div :class="[ classStyle ]" :id="[ idProp ]">
          <img src="static/images/store/icon-close-back-popup.svg" class="btn_close" @click="closeModal">
          <slot name="content"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'generic-modal',
  props: {
    hasExtraModalClass: {
      type: String,
      default: null,
    },
    modalKey: String,
    classStyle: String,
    idProp: String,
  },
  created() {
    this.initModal();
  },
  beforeDestroy() {
    this.unregisterModal(); // remove latest modal from stack
  },
  methods: {
    ...mapMutations('common', [
      'registerModal',
      'unregisterModal',
    ]),
    initModal() {
      this.registerModal({ value: this.modalKey }); // add modal to stack
    },
    closeModal() {
      this.$emit('close'); // inform parent
    },
    isActiveModal() {
      return this.getActiveModal === this.modalKey;
    },
  },
  computed: {
    ...mapGetters('common', [
      'getActiveModal',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/sharedcomponents/GenericModal.vue